import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './BreadcrumbBar.scss';

export type Crumb = { label: string; to?: string };

type BreadcrumbBarProps = {
  crumbs: Crumb[];
  backTo?: string;
};

const BreadcrumbBar: React.FC<BreadcrumbBarProps> = ({ crumbs, backTo = '/dashboard/home' }) => {
  const navigate = useNavigate();
  const current = crumbs[crumbs.length - 1];

  return (
    <nav className="db-breadcrumb" aria-label="Breadcrumb">
      <button
        type="button"
        className="db-breadcrumb__back"
        onClick={() => navigate(backTo)}
        aria-label="Quay lại Tổng quan"
      >
        <i className="material-icons">arrow_back</i>
        <span className="db-breadcrumb__back-label">Quay lại</span>
      </button>

      <ol className="db-breadcrumb__list">
        {crumbs.map((crumb, idx) => {
          const isLast = idx === crumbs.length - 1;
          return (
            <li key={`${crumb.label}-${idx}`} className="db-breadcrumb__item">
              {crumb.to && !isLast ? (
                <Link to={crumb.to} className="db-breadcrumb__link">{crumb.label}</Link>
              ) : (
                <span className="db-breadcrumb__current" aria-current="page">{crumb.label}</span>
              )}
              {!isLast && (
                <i className="material-icons db-breadcrumb__sep" aria-hidden="true">chevron_right</i>
              )}
            </li>
          );
        })}
      </ol>

      <span className="db-breadcrumb__current-mobile" aria-current="page">
        {current?.label}
      </span>
    </nav>
  );
};

export default BreadcrumbBar;
